/**
 * Identity for a chat entry. Needed as a React key: editing a message truncates the list,
 * so the same index goes on to hold a different message and index keys would let one
 * bubble's local state (e.g. "editing") leak into its replacement.
 */
export function createMessageId(): string {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
